module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button",
    class: {
      button_border: _vm.border, disabled: _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit("click")
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d94ba59a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/purchases/components/cancellation/components/button/Button.vue
// module id = 4febbe8db904d42433ed
// module chunks = 89